import { getGPTPrompt } from "./getGPTPrompt.js"
import { getGPTTokens } from "./getGPTTokens.js"
import { getModelToUse } from "./getModelToUse.js"

export const estimateTokens = ({
	taskName,
	taskInput,
	taskInputType,
	targetLang = null,
}) => {
	if (!taskName || !taskInput || !taskInputType) {
		return null
	}

	let systemPromptTokens = 0
	let inputTokens = 0
	let estimatedOutputTokens = 0

	const systemPrompt = getGPTPrompt(taskName, taskInputType, targetLang)
	systemPromptTokens = getGPTTokens({
		taskInput: systemPrompt,
		taskInputType: "title",
	}) // Title as taskInputType to avoid JSON.stringify for tasks for variants
	inputTokens = getGPTTokens({ taskInput, taskInputType })

	if (inputTokens > 0) {
		if (taskInputType === "description" && taskName === "translate") {
			// inputTokens = 220
			estimatedOutputTokens = inputTokens * 0.95
		} else if (taskInputType === "description" && taskName === "reword") {
			inputTokens = inputTokens * 0.85
			estimatedOutputTokens = 220
		} else if (taskInputType === "variants") {
			// 35 tokens for each of the variant object structure
			// { "variantId": "gid://shopify/ProductVariant/43271676231878", "originalValue": "", "newValue":null, "optPos":0 }
			// 20 tokens for input overall object structure (not including the individual variants array structure)
			// { "productId": "gid://shopify/Product/7987117129926", "variants":[] }
			// ~40 tokens for the options array structure
			// { "options":[{"originalValue":"Size","newValue":null,"optPos":0}, {"originalValue":"Light Color","newValue":null,"optPos":1}] }

			inputTokens = inputTokens + taskInput.length * 1.5 * 35 + 20 + 40
			estimatedOutputTokens = inputTokens * 1.1 // null in the variant object structure will be replaced with a translated value
		} else {
			estimatedOutputTokens = inputTokens * 0.95 // 95% length of input on average
		}
	}

	const model = getModelToUse({
		taskName,
		taskInputType,
		taskInputTokens: inputTokens,
	})

	return {
		estimatedInputTokens: inputTokens + systemPromptTokens,
		estimatedOutputTokens,
		model,
	}
}
